import React from 'react';
import { LegalPage } from './LegalPages';
import { contactInfo } from '../mock';
import { useLang } from '../context/LanguageContext';

export default function ShippingPolicy() {
  const { lang } = useLang();
  return (
    <LegalPage title={lang === 'en' ? 'Shipping & Delivery Policy' : 'शिपिंग और डिलिवरी नीति'} subtitle={lang === 'en' ? 'How Prasad and puja items reach you' : 'प्रसाद और पूजा सामग्री आप तक कैसे पहुंचती है'}>
      <p>
        This Shipping Policy explains how Navavidha Bhakti dispatches physical items such as
        Prasad, Rudraksha Mala, Vastra and Yantras to devotees who have booked pujas through
        {' '}{contactInfo.domain}.
      </p>

      <h2>1. What is Shipped</h2>
      <ul>
        <li><b>Prasad</b> — sanctified food items (dry sweets, laddoos, tulsi, akshat, kumkum, etc.).</li>
        <li><b>Puja Samagri add-ons</b> you selected — Rudraksha Mala, Vastra, Nariyal &amp; Chunri, Yantra, Kalash items.</li>
        <li><b>Sankalp Certificate</b> and printed puja details (for Family / Joint Family packages).</li>
      </ul>

      <h2>2. Shipping Coverage</h2>
      <ul>
        <li>We ship <b>PAN India</b> to all serviceable pin codes via reputed courier partners.</li>
        <li><b>International shipping</b> is available on request for selected countries. Please email
          <a href={`mailto:${contactInfo.email}`}> {contactInfo.email}</a> before booking to confirm.</li>
      </ul>

      <h2>3. Shipping Timeline</h2>
      <ul>
        <li>Prasad is dispatched within <b>3–5 business days</b> after the puja is performed.</li>
        <li>Delivery typically completes within <b>7–10 business days</b> for metro cities and
          <b> 10–14 business days</b> for remote areas across India.</li>
        <li>Custom items (Rudraksha, personalised Vastra) may take up to <b>15 business days</b>.</li>
      </ul>

      <h2>4. Shipping Charges</h2>
      <ul>
        <li>Standard shipping is included in the puja package price for <b>Family</b> and
          <b> Joint Family</b> packages within India.</li>
        <li>For Individual and 2 Person packages, a nominal Prasad Home Delivery add-on
          (<b>₹ 149</b>) is available at checkout.</li>
        <li>International shipping is charged separately based on destination and package weight.</li>
      </ul>

      <h2>5. Tracking</h2>
      <p>
        Once the parcel is dispatched, a tracking link will be sent to your registered
        WhatsApp and email. You can also request tracking status by writing to us.
      </p>

      <h2>6. Delivery Attempts</h2>
      <p>
        Our courier partners typically make up to <b>3 delivery attempts</b>. Please ensure
        someone is available at the shipping address, or select an alternate address at
        checkout. If the parcel is returned to origin due to non-availability, re-shipping
        charges may apply.
      </p>

      <h2>7. Damaged / Missing Items</h2>
      <p>
        If you receive a damaged, tampered or incomplete parcel, please <b>record an
        unboxing video</b> and email it to <a href={`mailto:${contactInfo.email}`}>{contactInfo.email}</a>
        within <b>48 hours</b> of delivery. We will investigate and replace/refund at our discretion.
      </p>

      <h2>8. Incorrect Address</h2>
      <p>
        We ship only to the address provided during booking. Address changes after dispatch
        are not possible. If the address is incorrect and parcel returns to origin,
        re-shipping charges will apply.
      </p>

      <h2>9. Force Majeure</h2>
      <p>
        Delivery times may be affected by natural calamities, courier strikes, national
        holidays, festival load or government restrictions. In such cases, we will do our
        best to keep you informed proactively.
      </p>

      <h2>10. Contact for Shipping Queries</h2>
      <p>
        Email <a href={`mailto:${contactInfo.email}`}>{contactInfo.email}</a> or WhatsApp
        <a href={`https://wa.me/${contactInfo.whatsapp}`}> {contactInfo.phone}</a> with your
        booking ID for any delivery-related question.
      </p>
    </LegalPage>
  );
}
